import LoadableComp   from 'components/LoadableComp';

const loadableComponent = (props) => {
    return <LoadableComp {...props}/>
}

export const fn_getComponent = loadableComponent;